import React from 'react';
import { Currency } from '../../../ui-toolkit';
import { FeeTextComponent } from './FeeTextComponent';
import { eRowPresentationStyle } from '../../../types/clientPortal/Fees/eRowPresentationStyle';

export const FeeAmount: React.FC<{ value: number | null; style: eRowPresentationStyle }> = ({ value, style }) => (
  <FeeTextComponent style={style}>
    <Currency value={value} emptyContent={style === eRowPresentationStyle.header ? '' : '$0.00'} />
  </FeeTextComponent>
);
